import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/20/solid"

const BookFooter = ({ previous, next }: { previous?: string; next?: string }) => {
  const bookLink = (title: string) =>
    `${encodeURIComponent(title.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))}.html`
  const className = "flex items-center py-1 text-lg text-sky-700 no-underline"
  return (
    <footer
      className="fixed bottom-0 z-10 flex w-full
      justify-between overflow-hidden bg-gradient-to-r from-white
     to-sky-50/90 px-4 py-2 shadow"
    >
      {previous ? (
        <a href={bookLink(previous)} className={className + " pr-3"}>
          <ChevronLeftIcon className="size-8 text-sky-700/40" />
          {previous}
        </a>
      ) : (
        <span></span>
      )}
      {next && (
        <a href={bookLink(next)} className={className + " pl-3"}>
          {next} <ChevronRightIcon className="size-8 text-sky-700/40" />
        </a>
      )}
    </footer>
  )
}

export default BookFooter
